"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var DocumentsExportDialogComponent = /** @class */ (function () {
    function DocumentsExportDialogComponent(dialogRef, documentExportData, applicationPropertiesService, currentLanguageProvider, http) {
        this.dialogRef = dialogRef;
        this.documentExportData = documentExportData;
        this.applicationPropertiesService = applicationPropertiesService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.http = http;
    }
    DocumentsExportDialogComponent.getConfig = function (entityId, entityName, categoryId, documentsCount) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        dialogConfig.data = {
            categoryId: categoryId,
            entityId: entityId,
            documentsCount: documentsCount,
            entityName: entityName
        };
        return dialogConfig;
    };
    DocumentsExportDialogComponent.prototype.download = function () {
        var _this = this;
        var currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage();
        var serviceUrl$ = Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty('ejustice-document-service-url'));
        Observable_1.Observable.zip(serviceUrl$, currentLanguageId$).pipe(operators_1.switchMap(function (data) {
            var serviceUrl = data[0];
            var languageId = data[1].getId();
            var categoryId = _this.documentExportData.categoryId;
            var entityId = _this.documentExportData.entityId;
            var url = serviceUrl + "/document-operations/export?categoryId=" + categoryId + "&entityId=" + entityId + "&languageId=" + languageId;
            return _this.http.post(url, {}, { responseType: 'arraybuffer' });
        })).subscribe(function (response) {
            var blob = new Blob([response], { type: 'application/zip' });
            window.open(window.URL.createObjectURL(blob));
            _this.dialogRef.close();
        });
    };
    DocumentsExportDialogComponent.prototype.onCancel = function () {
        this.dialogRef.close();
    };
    DocumentsExportDialogComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-documents-export-dialog',
            template: require('./documents-export-dialog.component.html'),
            styles: [require('./documents-export-dialog.component.css')]
        }),
        __param(1, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef, Object, idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], DocumentsExportDialogComponent);
    return DocumentsExportDialogComponent;
}());
exports.DocumentsExportDialogComponent = DocumentsExportDialogComponent;
//# sourceMappingURL=documents-export-dialog.component.js.map